"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateFeeEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Field_1 = require("../../../Form/Field");
const UpdateFeeEditor = (props) => {
    const { field } = props;
    return (react_1.default.createElement(Field_1.FormField, { autoComplete: 'off', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:updateFee', defaultMessage: 'Update fee' }), name: 'update-fee', error: field.error, value: field.input, onChange: field.onEvent, disabled: field.disabled, hidden: field.hidden }));
};
exports.UpdateFeeEditor = UpdateFeeEditor;
//# sourceMappingURL=updateFee.js.map